import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
import { TopDisplay } from "../../../components";
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
// import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Loader } from "../../../customs";
import apiCall from '../../../utils/apiCall';
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom, modalAtom} from "../../../context";
import styled from "@emotion/styled";
import { downloadApi } from "../../../api";
import {
  Grid,
  GridItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'



const src=`/public-assets/upload_icon.png`;

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function DueInductionReport() {
  const [search, set_search] = useState("");
  const [statusPrompt, setStatusPrompt] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 100;

 const { data, isLoading } = useQuery(
  ["all-induction", search, statusPrompt, pageNumber],
  async () => {
    const params: any = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      searchQuery: search || "",
    };

    // ⬅️ IMPORTANT FIX: only add status if user selected one
    if (statusPrompt) {
      params.status = statusPrompt;
    }

    const response = await apiCall().get(
      "/Exam/students/dueForInduction",
      { params }
    );

    return response.data;
  },
  {
    keepPreviousData: true,
  }
);


  const filter_data = data?.reportItems || [];
  const totalPages = data?.PageCount || 1;
  const totalCount = data?.TotalCount || 0;

  const handleReload = () => {
    set_search("");
    setStatusPrompt("");
    setPageNumber(1);
  };

  const handleDownload = useMutation({
    mutationFn: async () => {
      let url = `/ExamReport/downloadDueForInductionReport`;

      if (statusPrompt) {
        url += `?statusPrompt=${encodeURIComponent(statusPrompt)}`;
      }

      return await downloadApi(url, "POST", {}, {}, true);
    },
    onSuccess: (file) => {
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.download = "induction-report.xlsx";
      link.click();
    },
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="Induction Report"
            button_array={[
              <Button
                bg="var(--dark-green-color)"
                color="white"
                leftIcon={<DownloadIcon />}
                onClick={() => handleDownload.mutate()}
                disabled={handleDownload.isLoading}
              >
                {handleDownload.isLoading ? "Downloading..." : "Download Report"}
              </Button>,
            ]}
          />

          {/* FILTERS */}
          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="300px" bg="white" borderColor="green">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>

              <Input
                value={search}
                onChange={(e) => {
                  set_search(e.target.value);
                  setPageNumber(1);
                }}
                placeholder="Search by Student No"
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "12px",
                  cursor: "pointer",
                }}
                onClick={handleReload}
              >
                <ReloadIcon />
              </span>
            </InputGroup>

            <Select
              width="180px"
              bg="white"
              borderColor="green"
              value={statusPrompt}
              onChange={(e) => {
                setStatusPrompt(e.target.value);
                setPageNumber(1);
              }}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Inducted">Inducted</option>
              <option value="DueforInduction">Due for Induction</option>
              <option value="InvitedForInduction">Invited for Induction</option>
            </Select>
          </Flex>

          {/* HEADER */}
          <Flex mt="25px" flexDir="column">
            <Heading fontSize="1rem">All Due for Induction Reports</Heading>
            <Text fontSize=".8rem">
              Showing {(pageNumber - 1) * pageSize + 1} -{" "}
              {Math.min(pageNumber * pageSize, totalCount)} of {totalCount}
            </Text>
          </Flex>

          {/* TABLE */}
          {filter_data.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>First Name</Th>
                    <Th>Last Name</Th>
                    <Th>Student No</Th>
                    <Th>Email</Th>
                    <Th>Phone</Th>
                    <Th>Induction-Diet</Th>
                    <Th>IsInvited</Th>
                    <Th>HasApplied</Th>
                    <Th>IsOldStudent</Th>
                    <Th>IsMoved</Th>
                    <Th>NewMembershipNo</Th>
                    <Th>Status</Th>
                    <Th></Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {filter_data.map((e: any, index: number) => (
                    <Tr key={e.StudentNo}>
                      <Td>{e.FirstName}</Td>
                      <Td>{e.LastName}</Td>
                      <Td>{e.StudentNo}</Td>
                      <Td>{e.Email}</Td>
                      <Td>{e.PhoneNumber}</Td>
                      <Td>{e.DietDueForInduction}</Td>
                      <Td>{e.IsInvitedForInduction ? "Yes" : "No"}</Td>
                      <Td>{e.HasAppliedForInduction ? "Yes" : "No"}</Td>
                      <Td>{e.IsOldStudent ? "Yes" : "No"}</Td>
                      <Td>{e.IsMovedToMembership ? "Yes" : "No"}</Td>
                      <Td>{e.FinalMembershipNo ? "Yes" : "No"}</Td>
                      <Td>{e.Status}</Td>
                      <Td>
                        <Option index={index} candidate={e} />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            "No students found"
          )}

          {/* PAGINATION */}
          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              previousLabel="<"
              pageRangeDisplayed={3}
              pageCount={totalPages}
              onPageChange={(e) => setPageNumber(e.selected + 1)}
            />
          </StylePaginateBox>
        </Box>
      )}
    </>
  );
}

const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'View Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

  
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}
const ViewProfile = (props:any) =>{
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      {/* <Image
        src="/public-assets/profile.png"
        width="150px"
        height="150px"
        objectFit="contain"
        objectPosition="center"
        alt="profile"
      /> */}
      <Flex gap="20px">
        {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
        <Text width="150px"  fontWeight="500" color="var(--light-text)">First Name</Text>
        <Text> {props.candidate.FirstName}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Last Name</Text>
        <Text fontWeight="500">{props.candidate.LastName || 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">StudentNo</Text>
        <Text fontWeight="500">
          {props.candidate.StudentNo || 'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">IsInvited</Text>
        <Text fontWeight="500">
          {props.candidate.IsInvitedForInduction?'YES' : 'NO'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">HasApplied</Text>
        <Text fontWeight="500">
          {props.candidate.HasAppliedForInduction? 'YES':'NO'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">IsOldStudent</Text>
        <Text fontWeight="500">
          {props.candidate.IsOldStudent?'YES':'NO'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">IsMoved</Text>
        <Text fontWeight="500">
          {props.candidate.IsMovedToMembership?'YES':'No'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">NewMemberNo</Text>
        <Text fontWeight="500">
          {props.candidate.FinalMembershipNo || 'N/A'}
        </Text>
      </GridItem >
      {/* <GridItem as={Flex} gap="20px">
        <Text width="150px" fontWeight="500" color="var(--light-text)">Status</Text>
        <Text fontWeight="500">{props.candidate.Status || 'Pending'}</Text>
      </GridItem> */}
    </Grid>
  </Flex>
  )}


  